const themeStyles = colors => {
  const defaultStyles = {
    rangeColorScale: {
      position: 'relative',
      margin: '50px 0px 30px 0px'
    },
    stringLabel: {
      color: colors.secondaryGray,
      marginBottom: 4
    },
    rangeBar: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      height: 15,
      borderRadius: 15,
      overflow: 'hidden',
      color: colors.black
    },
    pointer: position => {
      return {
        position: 'absolute',
        bottom: '100%',
        left: position,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        transform: 'translate(calc(-50% - 0.25px))'
      }
    },
    currentValue: (inRange = 'within') => {
      const color = inRange => ({
        lower: colors.continueYellow,
        upper: colors.continueYellow,
        within: colors.completedGreen
      }[inRange]);
      return {
        width: 'fit-content',
        background: color(inRange),
        padding: '5px 10px',
        borderRadius: '15px',
        minWidth: 40,
        textAlign: 'center'
      }
    },
    belowRangeArea: {
      width: '50%',
      height: '100%',
      background: colors.continueYellow
    },
    withinRange: {
      width: '100%',
      height: '100%',
      background: colors.completedGreen,
      borderRight: `1px solid ${colors.white}`,
      borderLeft: `1px solid ${colors.white}`
    },
    aboveRange: {
      width: '50%',
      height: '100%',
      background: colors.continueYellow
    },
    thresholdValue: {
      position: 'absolute',
      transform: 'translate(-50%)',
      top: 20
    },
    value: {
      color: '#000000'
    }
  }
  return defaultStyles
}
export default themeStyles
